/**
 * Unauthorized Page
 * Displayed when user doesn't have required permissions
 */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';

const UnauthorizedPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 200px)',
        textAlign: 'center',
      }}
    >
      <LockIcon sx={{ fontSize: 80, color: theme.palette.error.main, mb: 2 }} />
      <Typography variant="h2" gutterBottom>
        403 - Unauthorized
      </Typography>
      <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 4 }}>
        You don't have permission to access this page.
      </Typography>
      <Button className="action-btn process-btn" variant="contained" color="primary" onClick={() => navigate('/home')}>
        Go to Home
      </Button>
    </Box>
  );
};

export default UnauthorizedPage;
